import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withModal from '../../../../../../../components/global/modal/withModal';
import PhotoFinderCreditItemsCheckout from './PhotoFinderCreditItemsCheckout';

const propTypes = {
  className: PropTypes.string,
  actionProps: PropTypes.shape({
    title: PropTypes.node,
    basename: PropTypes.string.isRequired,
    content: PropTypes.node,
    onCheckoutSuccess: PropTypes.func,
  }),
  onRequestClose: PropTypes.func.isRequired,
};

const PhotoFinderCreditItemsCheckoutModal = ({
  className,
  actionProps = {},
  onRequestClose,
  ...props
}) => {
  const classes = classNames({
    'photo-finder-subscription-checkout-modal': true,
    [className]: !!className,
  });

  const { title, basename, onCheckoutSuccess, onPayPerPhoto } = actionProps;

  return (
    <div className={classes}>
      <PhotoFinderCreditItemsCheckout
        title={title}
        basename={basename}
        onCheckoutSuccess={async () => {
          onRequestClose();
          await onCheckoutSuccess?.();
        }}
        onPayPerPhoto={onPayPerPhoto}
        onRequestClose={onRequestClose}
        {...props}
      />
    </div>
  );
};

PhotoFinderCreditItemsCheckoutModal.propTypes = propTypes;

export const PHOTO_FINDER_CREDIT_ITEMS_CHECKOUT_MODAL =
  'PHOTO_FINDER_CREDIT_ITEMS_CHECKOUT_MODAL';

export default withModal(PhotoFinderCreditItemsCheckoutModal, {
  name: PHOTO_FINDER_CREDIT_ITEMS_CHECKOUT_MODAL,
  size: 'sm',
  type: 'full',
  hideHeader: false,
});
